import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonBadgeCounter } from './BadgeCounter.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonBadgeCounter({ prefix }));
}
